import Colors from 'builder/styles/colors'

export const THEME = {
  documents: {
    primary: Colors.Blue50,
    base: Colors.Blue40,
    soft: Colors.Blue10,
    muted: Colors.Blue20,
    text: Colors.Blue80,
    badge: Colors.Blue15,
  },
  jobs: {
    primary: Colors.Indigo50,
    base: Colors.Indigo40,
    soft: Colors.Indigo10,
    muted: Colors.Indigo20,
    text: Colors.Indigo80,
    badge: Colors.Indigo15,
  },
  careers: {
    primary: Colors.Green50,
    base: Colors.Green40,
    soft: Colors.Green10,
    muted: Colors.Green20,
    text: Colors.Green80,
    badge: Colors.Green15,
  },
}
